import React, { Component } from 'react'
import { connect } from 'react-redux'

import setActiveStep from '../../../actions/activeStepActions'

class BkFlowRoomCardSkipStepButton extends Component {
  render() {
    const {
      configData,
      activeStep,
      handleSkipToPayment,
      customClass
    } = this.props

    const hotelLabels = configData.hotel.labels[0]

    return (
      <button
        className={ customClass ?
          'bk-flow-room__skip-steps btn btn-primary btn-xl flex center-xs ' + customClass
        :
          'bk-flow-room__skip-steps btn btn-primary btn-xl flex center-xs'
        }
        onClick={ () => handleSkipToPayment(activeStep) }
      >
        { hotelLabels.continue }
      </button>
    )
  }

}

const mapDispatchToProps = (dispatch) => ({
  handleSkipToPayment(activeStep) {
    return dispatch(setActiveStep(activeStep + 1))
  }
})

function mapStateToProps(state) {
  return {
    configData: state.configData.configuration,
    activeStep: state.activeStepData.activeStep,
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(BkFlowRoomCardSkipStepButton)



// WEBPACK FOOTER //
// ./src/components/room/elements/BkFlowRoomCardSkipStepButton.js